import { getParameterByName } from '../utils/url-utils';

const inPageNav = () => {
  // Fixed navbar behavior
  const body = document.getElementsByTagName('body')[0];
  const headerDiv = document.querySelector('.header');
  const headerContentDiv = document.querySelector('.header-main-section');
  const anchors = document.querySelectorAll('.page-anchor');
  const inPageNavDiv = document.querySelector('.in-page-nav');
  const mobileBrkpt = 768;
  let addOffsetDiv = document.querySelector('main');
  const promoBar = document.querySelector('.promo-bar');
  // let currentAnchor = '';
  if (promoBar) {
    addOffsetDiv = promoBar;
  }
  let initLoadHeaderOffset = 24;
  if (headerDiv === null || inPageNavDiv === null) {
    return;
  }
  const inPageNavYPos = inPageNavDiv.offsetTop;
  const updateOffsetHeight = () => {
    if (window.innerWidth <= mobileBrkpt) {
      return;
    }
    let headerFixedOffset = 0;
    const headerOffset = headerContentDiv.clientHeight;
    const addFixedAtY = inPageNavYPos - headerOffset;
    /* // Check if header is fixed
    const headerStyles = window.getComputedStyle(headerDiv);
    if (headerStyles.getPropertyValue('position').toLowerCase() === 'fixed') {
      addFixedAtY = inPageNavYPos - headerOffset;
    } */
    if (addFixedAtY <= window.pageYOffset) {
      headerFixedOffset = Math.min(window.pageYOffset - addFixedAtY, headerContentDiv.offsetHeight) * -1;
      inPageNavDiv.classList.add('is-fixed');
      inPageNavDiv.style.top = `${headerOffset + headerFixedOffset}px`;
      addOffsetDiv.style.marginTop = `${inPageNavDiv.offsetHeight}px`;
      // console.log(`${headerFixedOffset}px`);
      // Slide up header and in-page nav,
      // so in-page nav is locked to top of screen
      headerDiv.style.top = `${headerFixedOffset}px`;
    } else {
      inPageNavDiv.classList.remove('is-fixed');
      inPageNavDiv.removeAttribute('style');
      // addOffsetDiv.removeAttribute('style');
      headerDiv.removeAttribute('style');
    }
  };

  // Scrolling & Anchors
  const updateAnchorOffset = () => {
    let offset = 0;
    if (headerDiv) {
      offset = `${(((headerContentDiv.clientHeight + inPageNavDiv.clientHeight) - initLoadHeaderOffset) * -1)}px`;
    }
    for (let i = 0; i < anchors.length; i++) { /* eslint-disable-line no-plusplus */
      anchors[i].style.top = offset;
    }
    // Reset to 0 after applying on load
    if (initLoadHeaderOffset !== 0) {
      initLoadHeaderOffset = 0;
    }
  };

  const getAnchorPosition = (anchor) => {
    const div = document.querySelector(`a[data-anchor-name="${anchor}"]`);
    if (div) {
      if (!inPageNavDiv.classList.contains('is-fixed')) {
        return div.offsetTop - 60;
      }
      return div.offsetTop;
    }
    return 0;
  };

  const scrollToPosition = (pos) => {
    window.scrollTo({
      top: pos,
      behavior: 'smooth',
    });
  };

  const updateHashAfterDelay = (anchor) => { /* eslint-disable-line no-unused-vars */
    setTimeout(() => {
      // window.location.hash = anchor;
      // currentAnchor = anchor;
    }, 250);
  };

  const removeJumpToMenu = () => {
    inPageNavDiv.querySelector('ul').classList.remove('open-jump-to-menu');
  };

  const getMenuBounds = (x, y) => {
    const menu = document.querySelector('.open-jump-to-menu');
    if (menu === null) {
      return false;
    }
    const menuH = menu.offsetHeight;
    const menuW = menu.offsetWidth; // 270;
    const menuY = menu.getBoundingClientRect().top;
    if (x > menuW) {
      return true;
    }
    if (y < menuY || y > menuY + menuH) {
      return true;
    }
    return false;
  };

  const onBodyClickOffNav = (bodyEvent) => {
    const div = document.querySelector('.open-jump-to-menu');
    if (div === null) {
      return;
    }
    if (getMenuBounds(bodyEvent.clientX, bodyEvent.clientY)) {
      removeJumpToMenu();
      body.removeEventListener('click', onBodyClickOffNav);
    }
  };

  window.addEventListener('resize', () => {
    updateAnchorOffset();
    removeJumpToMenu();
    if (window.innerWidth > 768) {
      removeJumpToMenu();
    }
  });

  window.addEventListener('scroll', () => {
    updateOffsetHeight();
    if (window.innerWidth <= mobileBrkpt) {
      return;
    }
    if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight && anchors.length > 0) {
      const anchorName = anchors[anchors.length - 1].getAttribute('data-anchor-name');
      let setAsActive = inPageNavDiv.querySelector(`[href*="#${anchorName}"]`);
      if (setAsActive === null) {
        return;
      }
      setAsActive = setAsActive.parentNode;
      // If nav item is already active, return
      if (setAsActive.classList.contains('active')) {
        return;
      }
      // Remove active state
      const currentActive = inPageNavDiv.querySelector('.active');
      if (currentActive) {
        currentActive.classList.remove('active');
      }
      // Set new active and update hash
      setAsActive.classList.add('active');
      updateHashAfterDelay(anchorName);
      return;
    }
    window.updateAnchorOffset(); // Weird scope issue, so added reference to window
    for (let i = anchors.length - 1; i >= 0; i--) { /* eslint-disable-line no-plusplus */
      if (anchors[i].offsetTop <= window.pageYOffset) {
        const anchorName = anchors[i].getAttribute('data-anchor-name');
        let setAsActive = inPageNavDiv.querySelector(`[href*="#${anchorName}"]`);
        if (setAsActive === null) {
          return;
        }
        setAsActive = setAsActive.parentNode;
        // If nav item is already active, return
        if (setAsActive.classList.contains('active')) {
          return;
        }
        // Remove active state
        const currentActive = inPageNavDiv.querySelector('.active');
        if (currentActive) {
          currentActive.classList.remove('active');
        }
        // Set new active and update hash
        setAsActive.classList.add('active');
        updateHashAfterDelay(anchorName);
        return;
      }
    }
  });

  // Load
  updateOffsetHeight();
  updateAnchorOffset();
  window.updateAnchorOffset = updateAnchorOffset;
  // Check to see if url is hashed and if hash matches page anchor
  const param = getParameterByName('section');
  if (param !== '') {
  // if (window.location.hash) {
    // const anchor = window.location.hash.substr(1);
    const anchor = param;
    const pos = getAnchorPosition(anchor);
    scrollToPosition(pos);
    if (pos !== 0) {
      updateHashAfterDelay(anchor);
    }
  }

  // Event handlers
  [].map.call(document.querySelectorAll('a, .in-page-nav-item button'), btn => (
  // [].map.call(inPageNavDiv.querySelectorAll('.in-page-nav-item a, .in-page-nav-item button'), btn => (
    btn.addEventListener('click', (event) => {
      /* if (!btn.classList.contains('anchor-link')) {
        return;
      } */
      // event.preventDefault();
      // Do not attach anchoring to ".jump-to-section"
      if (btn.parentNode.classList.contains('jump-to-section')) {
        event.preventDefault();
        if (inPageNavDiv.querySelector('ul').classList.contains('open-jump-to-menu')) {
          inPageNavDiv.querySelector('ul').classList.remove('open-jump-to-menu');
          body.removeEventListener('click', onBodyClickOffNav);
        } else {
          inPageNavDiv.querySelector('ul').classList.add('open-jump-to-menu');
          body.addEventListener('click', onBodyClickOffNav);
        }
        return;
      }
      let anchor = btn.getAttribute('href');
      if (anchor) {
        const url = window.location.href;
        const urlMatch = anchor.substring(0, anchor.indexOf('#')) === url.substr(0, url.indexOf('#'));
        if (anchor.indexOf('#') === 0 || (anchor.indexOf('#') !== -1 && urlMatch)) {
          event.preventDefault();
          anchor = anchor.substr(anchor.indexOf('#') + 1);
          const pos = getAnchorPosition(anchor);
          scrollToPosition(pos);
          if (pos !== 0) {
            updateHashAfterDelay(anchor);
          }
        }
      }
    })
  ));
};

export default inPageNav;
